import { Route } from '@angular/router';
import { authGuard } from '@routes/guards/auth.guard';
import { guard } from '@routes/guards/guard-factory';
import { guardCreate } from '@routes/guards/guard-create';

export const usersRoutes: Route[] = [
    {
        path: 'users',
        title: 'PRSS | Список пользователей',
        loadComponent: () =>
            import('@pages/guids/users/users.component').then((c) => c.UsersComponent),
        canActivate: [authGuard, guard('users_list')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Пользователи', url: null },
            ],
            reuse: true,
            searchString: true,
        },
    },
    {
        path: 'users/create',
        title: 'PRSS | Создание пользователя',
        loadComponent: () =>
            import('@pages/guids/users/create-user/create-user.component').then(
                (c) => c.CreateUserComponent,
            ),
        canActivate: [authGuard, guard('users_create')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Пользователи', url: '/users/' },
                { name: 'Создание', url: null },
            ],
            searchString: false,
        },
    },
    {
        path: 'users/:id',
        title: 'PRSS | Редактирование пользователя',
        loadComponent: () =>
            import('@pages/guids/users/user-details/users-details.component').then(
                (c) => c.UsersDetailsComponent,
            ),
        canActivate: [authGuard, guard('users_list'), guardCreate('users_create')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Пользователи', url: '/users/' },
            ],
            searchString: false,
        },
    },
];
